import { API_PDC_URL_V1 } from "../../../config";

import { callWithRetry } from "../../services/callWithRetry";
import { overflowNotificationConstants } from "../overflowNotification";

import { createHttpHeaderWithAuthorization } from "../../services/http-header";
import { uploadDocuments } from "../documents/upload";

export const foldersConstants = {
  GET_FOLDERS_START: "GET_FOLDERS_START",
  GET_FOLDERS_SUCCESS: "GET_FOLDERS_SUCCESS",
  GET_FOLDERS_ERROR: "GET_FOLDERS_ERROR",

  CREATE_FOLDERS_START: "CREATE_FOLDERS_START",
  CREATE_FOLDERS_SUCCESS: "CREATE_FOLDERS_SUCCESS",
  CREATE_FOLDERS_ERROR: "CREATE_FOLDERS_ERROR",

  CREATE_FOLDERS_WITH_UPLOAD_START: "CREATE_FOLDERS_WITH_UPLOAD_START",
  CREATE_FOLDERS_WITH_UPLOAD_SUCCESS: "CREATE_FOLDERS_WITH_UPLOAD_SUCCESS",
  CREATE_FOLDERS_WITH_UPLOAD_ERROR: "CREATE_FOLDERS_WITH_UPLOAD_ERROR",

  UPDATE_FOLDER_START: "UPDATE_FOLDER_START",
  UPDATE_FOLDER_SUCCESS: "UPDATE_FOLDER_SUCCESS",
  UPDATE_FOLDER_ERROR: "UPDATE_FOLDER_ERROR",

  UPDATE_DOCS_FOLDER_START: "UPDATE_DOCS_FOLDER_START",
  UPDATE_DOCS_FOLDER_SUCCESS: "UPDATE_DOCS_FOLDER_SUCCESS",
  UPDATE_DOCS_FOLDER_ERROR: "UPDATE_DOCS_FOLDER_ERROR",

  DELETE_FOLDER_START: "DELETE_FOLDER_START",
  DELETE_FOLDER_SUCCESS: "DELETE_FOLDER_SUCCESS",
  DELETE_FOLDER_ERROR: "DELETE_FOLDER_ERROR",

  GET_PREVIEW_FOLDER_DOCUMENT_START: "GET_PREVIEW_FOLDER_DOCUMENT_START",
  GET_PREVIEW_FOLDER_DOCUMENT_SUCCESS: "GET_PREVIEW_FOLDER_DOCUMENT_SUCCESS",
  GET_PREVIEW_FOLDER_DOCUMENT_ERROR: "GET_PREVIEW_FOLDER_DOCUMENT_ERROR",

  SEND_FOLDER_EMAIL_START: "SEND_FOLDER_EMAIL_START",
  SEND_FOLDER_EMAIL_SUCCESS: "SEND_FOLDER_EMAIL_SUCCESS",
  SEND_FOLDER_EMAIL_ERROR: "SEND_FOLDER_EMAIL_ERROR"
};

/**
 * Restituisce la lista di fascicoli secondo i filtri impostati
 *
 * @param {object} auth
 * @param {string} managerId
 * @param {string} itemId
 */
export function getFolders() {
  return (dispatch, getState) => {
    const auth = getState().auth;
    const managerId = getState().main.accountantIdSelected;
    const itemId = getState().main.clientIdSelected;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: foldersConstants.GET_FOLDERS_START
      });
      let request = {
        method: "GET",
        url: API_PDC_URL_V1 + `/folders?itemId=${itemId}&managerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: foldersConstants.GET_FOLDERS_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: foldersConstants.GET_FOLDERS_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

/**
 *
 * @param {object} auth
 * @param {string} managerId
 * @param {string} itemId
 * @param {object} bodyRequest
 */
export function createFolders(bodyRequest) {
  return (dispatch, getState) => {
    const auth = getState().auth;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: foldersConstants.CREATE_FOLDERS_START
      });

      let request = {
        method: "POST",
        url: API_PDC_URL_V1 + "/folders",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: bodyRequest
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: foldersConstants.CREATE_FOLDERS_SUCCESS,
            payload: { ...response.data, ...bodyRequest }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: foldersConstants.CREATE_FOLDERS_ERROR,
            payload: { error: err }
          });
          if (err && JSON.stringify(err).includes("409")) {
            dispatch({
              type: overflowNotificationConstants.SHOW_OVERFLOW,
              payload: {
                type: "warning",
                title: "Attenzione",
                message: "Esiste già un fascicolo con lo stesso nome."
              }
            });
          }
          reject(err);
        });
    });
  };
}

/**
 *
 * @param {object} auth
 * @param {string} managerId
 * @param {string} itemId
 * @param {string} folderId
 * @param {object} bodyRequest
 */
export function updateFolder(folderId, bodyRequest) {
  return (dispatch, getState) => {
    const auth = getState().auth;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: foldersConstants.UPDATE_FOLDER_START
      });

      let request = {
        method: "PUT",
        url: API_PDC_URL_V1 + "/folders/" + folderId,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: bodyRequest
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: foldersConstants.UPDATE_FOLDER_SUCCESS,
            payload: { ...response.data, ...bodyRequest }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: foldersConstants.UPDATE_FOLDER_ERROR,
            payload: { error: err }
          });
          reject(err);
        });
    });
  };
}

export function createFoldersWithUpload(
  auth, user, uploadedDocuments, myType, company, clientIdSelected, accountantIdSelected, requestBody, docs, onSave, visibleByStudioOnly
) {
  return (dispatch, getState) => {
    return new Promise(function() {
      let sender = "";
      let recipient = "";
      if (myType === "STUDIO") {
        sender = accountantIdSelected;
        recipient = clientIdSelected;
      } else {
        sender = clientIdSelected;
        recipient = accountantIdSelected;
      }
      let selectedCompany = company.companies.find((el) => {
        return el.id === clientIdSelected;
      });
      dispatch(uploadDocuments(
        sender,
        selectedCompany.partitaIva,
        uploadedDocuments,
        0, // categoria di default,
        recipient,
        null, // note,
        [], // metadata,
        selectedCompany.codiceFiscale,
        "WEB",
        false, // da proteggere false di default,
        myType,
        visibleByStudioOnly || false /* visibile solo allo studio false di default*/
      ))
        .then((res) => {
          const documents = getState().documents;
          const uploadedDocumentsIds = [...documents.upload.uploadedSingleDocument.documents];
          requestBody.queryParams.documentIds = [...docs, ...uploadedDocumentsIds];
          onSave(requestBody);
        })
        .catch((err) => {
          dispatch({
            type: foldersConstants.CREATE_FOLDERS_ERROR,
            payload: { error: err }
          });
        });
    });
  };
}

export function updateFoldersWithUpload(
  auth,
  user,
  uploadedDocuments,
  myType,
  company,
  clientIdSelected,
  accountantIdSelected,
  requestBody,
  docs,
  onUpdate,
  folderId
) {
  return (dispatch, getState) => {
    return new Promise(function() {
      let sender = "";
      let recipient = "";
      if (myType === "STUDIO") {
        sender = accountantIdSelected;
        recipient = clientIdSelected;
      } else {
        sender = clientIdSelected;
        recipient = accountantIdSelected;
      }
      let selectedCompany = company.companies.find((el) => {
        return el.id === clientIdSelected;
      });
      dispatch(uploadDocuments(
        sender,
        selectedCompany.partitaIva,
        uploadedDocuments,
        0, // categoria di default,
        recipient,
        null, // note,
        [], // metadata,
        selectedCompany.codiceFiscale,
        "WEB",
        false, // da proteggere false di default,
        myType,
        false /* visibile solo allo studio false di default*/
      ))
        .then((res) => {
          const documents = getState().documents;
          const uploadedDocumentsIds = [...documents.upload.uploadedSingleDocument.documents];
          requestBody.queryParams.documentIds = [...docs, ...uploadedDocumentsIds];
          onUpdate(folderId, requestBody);
        })
        .catch((err) => {
          dispatch({
            type: foldersConstants.CREATE_FOLDERS_ERROR,
            payload: { error: err }
          });
        });
    });
  };
}

export function updateDocsFolder(
  auth, managerCf, managerId, itemCf, itemId, foldersName, bodyRequest
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: foldersConstants.UPDATE_DOCS_FOLDER_START
      });

      let request = {
        method: "PATCH",
        url: API_PDC_URL_V1 + "/folders/addDocToFolders",
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: bodyRequest
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: foldersConstants.UPDATE_DOCS_FOLDER_SUCCESS,
            payload: { ...response.data, ...bodyRequest }
          });

          dispatch({
            type: overflowNotificationConstants.SHOW_OVERFLOW,
            payload: {
              type: "success",
              title: "OK",
              message: "Il documento è stato aggiunto ai fascicoli: " + foldersName
            }
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: foldersConstants.UPDATE_DOCS_FOLDER_ERROR,
            payload: { error: err }
          });
          reject(err);
        });
    });
  };
}

/**
 *
 * @param {object} auth
 * @param {string} managerId
 * @param {string} itemId
 * @param {string} folderId
 */
export function deleteFolder(folderId) {
  const additionalHeaders = {};

  return (dispatch, getState) => {
    const auth = getState().auth;

    return new Promise(function(resolve, reject) {
      let request = {
        method: "DELETE",
        url: API_PDC_URL_V1 + "/folders/" + folderId,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken),
          ...additionalHeaders
        }
      };

      dispatch({
        type: foldersConstants.DELETE_FOLDER_START
      });
      callWithRetry(
        auth, request, dispatch
      )
        .then((result) => {
          if (result.status === 200 || result.status === 202) {
            dispatch({
              type: foldersConstants.DELETE_FOLDER_SUCCESS,
              payload: result.data
            });
          } else {
            dispatch({
              type: foldersConstants.DELETE_FOLDER_ERROR,
              error: result
            });
          }
          resolve(result);
        })
        .catch((err) => {
          dispatch({
            type: foldersConstants.DELETE_FOLDER_ERROR,
            error: err
          });
          reject(err);
        });
    });
  };
}

export function sendEmailFolder(folderId, bodyRequest) {
  return (dispatch, getState) => {
    const auth = getState().auth;

    return new Promise(function(resolve, reject) {
      dispatch({
        type: foldersConstants.SEND_FOLDER_EMAIL_START
      });

      let request = {
        method: "POST",
        url: `${API_PDC_URL_V1}/folders/${folderId}/notify-download-link`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        },
        data: bodyRequest
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: foldersConstants.SEND_FOLDER_EMAIL_SUCCESS
          });
          resolve(response.data);
        })
        .catch((err) => {
          dispatch({
            type: foldersConstants.SEND_FOLDER_EMAIL_ERROR
          });
          reject(err);
        });
    });
  };
}
